import React, { Component } from "react";
import styled from "styled-components";
import PropTypes from "prop-types";
import { connect } from "react-redux";

import { LiveProvider, LiveEditor, LiveError, LivePreview } from "react-live";

import ErrorBoundary from "./ErrorBoundary";
import CodeNavigator from "./CodeNavigator";
import { doSetUserReactCode } from "../../redux/reducers";
import { saveBookInLocalStorage } from "../utils";

import "../prismStyles.css";

const Wrapper = styled.div`
  width: 100%;
  margin-bottom: ${props => props.theme.margins.lg};
`;

const MainPanel = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
`;

const ExerciseWrapper = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  width: 100%;
`;

const ErrorWrapper = styled.div`
  width: 100%;
  box-shadow: 0 40px 50px -30px rgba(0, 0, 0, 0.8);
`;

const Navigation = styled.div`
  width: 100%;
  display: flex;
`;

const Panel = styled.div`
  width: 49%;
  border-radius: ${props => props.theme.radius.xs};
  padding: ${props => props.theme.margins.md};
`;

const ResetPanel = Panel.extend`
  display: flex;
  padding: 0;
  padding-bottom: ${props => props.theme.margins.sm};
  justify-content: flex-end;
`;

const CodePanel = Panel.extend`
  position: relative;
  background: ${props => props.theme.colors.primaryDark};
  box-shadow: 0 40px 50px -30px rgba(0, 0, 0, 0.4);
  overflow-x: scroll;
  &:before {
    position: absolute;
    top: 5px;
    right: 5px;
    background: ${props => props.theme.colors.purple};
    color: ${props => props.theme.colors.transparent75};
    padding: 1px 3px;
    content: "react";
    font-size: ${props => props.theme.fontSizes.xs};
    z-index: 1000;
  }
`;

const ResultPanel = Panel.extend`
  background: white;
  border: 1px solid #eee;
  box-shadow: 0 40px 50px -30px rgba(0, 0, 0, 0.2);
`;

class ReactCodeBlock extends Component {
  static propTypes = {
    codeUser: PropTypes.string,
    blockNumber: PropTypes.string.isRequired,
    activeChapterId: PropTypes.number,
    codeId: PropTypes.string
  };

  onUserReactCodeChange = code => {
    const { onUserReactCodeChange, activeChapterId, codeId } = this.props;
    onUserReactCodeChange(activeChapterId, codeId, code);
  };

  componentWillReceiveProps(nextProps) {
    const { book } = this.props;
    const newBook = nextProps.book;

    if (!!newBook && book !== newBook) {
      saveBookInLocalStorage(newBook);
    }
  }

  shouldComponentUpdate({ codeUser }) {
    return this.props.codeUser === codeUser ? false : true;
  }

  render() {
    const { blockNumber, codeUser, activeChapterId, codeId } = this.props;

    return (
      <Wrapper data-blocknumber={blockNumber} className="block">
        <MainPanel>
          <Navigation>
            <ResetPanel>
              <CodeNavigator
                activeChapterId={activeChapterId}
                codeId={codeId}
                type="react"
              />
            </ResetPanel>
          </Navigation>

          <LiveProvider code={codeUser} mountStylesheet={false} noInline>
            <ExerciseWrapper>
              <CodePanel>
                <LiveEditor onChange={this.onUserReactCodeChange} />
              </CodePanel>

              <ResultPanel>
                <ErrorBoundary>
                  <LivePreview />
                </ErrorBoundary>
              </ResultPanel>
            </ExerciseWrapper>

            <ErrorWrapper className="error-wrapper">
              <LiveError />
            </ErrorWrapper>
          </LiveProvider>
        </MainPanel>
      </Wrapper>
    );
  }
}

const mapStateToProps = state => ({
  book: state.book
});

const mapDispatchToProps = dispatch => ({
  onUserReactCodeChange: (activeChapterId, codeId, code) =>
    dispatch(doSetUserReactCode(activeChapterId, codeId, code))
});

export default connect(mapStateToProps, mapDispatchToProps)(ReactCodeBlock);



// WEBPACK FOOTER //
// ./src/book/blocks/ReactCodeBlock.js